import React from "react";
const MoreSkills = () => {
  return (
    <React.Fragment>
      <div className="allSkills">
        <div>
          <h3>Languages</h3>
          <p>HTML</p>
          <p>CSS</p>
          <p>XML</p>
          <p>XSLT</p>
          <p>English (fluent)</p>
          <p>German (native)</p>
          <h3>Hard Skills</h3>
          <p>Relief Print (art.)</p>
          <p>Edging (art.)</p>
          <p>Screen print (art.)</p>
          <p>Photography (analogous/digital)</p>
          <p>making Kaiserschmarrn</p>
          <h3>Soft Skills</h3>
          <p>
            to keep the mystery alive:<br></br> I will tell you in person ;)
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MoreSkills;
